import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from './auth.js';
import { apiJson, apiFetch } from './api-client.js';

export function useApiQuery<T>(key: unknown[], path: string) {
  const { idToken } = useAuth();
  return useQuery<T>({
    queryKey: [...key, idToken],
    queryFn: () => apiJson<T>(path, idToken!),
    enabled: !!idToken
  });
}

export function useApiMutation(path: string, method: 'POST' | 'PATCH' = 'POST') {
  const { idToken } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body?: unknown) => {
      const res = await apiFetch(path, idToken!, {
        method,
        headers: { 'content-type': 'application/json' },
        body: body !== undefined ? JSON.stringify(body) : undefined
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    },
    onSuccess: () => qc.invalidateQueries()
  });
}
